import "core-js/modules/es.array.reverse.js";
var _class, _GetCapabilitiesStratum, _class2, _WebMapTileServiceCatalogItem;
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { computed, makeObservable, override, runInAction } from "mobx";
import defined from "terriajs-cesium/Source/Core/defined";
import GeographicTilingScheme from "terriajs-cesium/Source/Core/GeographicTilingScheme";
import WebMercatorTilingScheme from "terriajs-cesium/Source/Core/WebMercatorTilingScheme";
import WebMapTileServiceImageryProvider from "terriajs-cesium/Source/Scene/WebMapTileServiceImageryProvider";
import URI from "urijs";
import containsAny from "../../../Core/containsAny";
import isDefined from "../../../Core/isDefined";
import isReadOnlyArray from "../../../Core/isReadOnlyArray";
import TerriaError from "../../../Core/TerriaError";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import GetCapabilitiesMixin from "../../../ModelMixins/GetCapabilitiesMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import { InfoSectionTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import LegendTraits from "../../../Traits/TraitsClasses/LegendTraits";
import WebMapTileServiceCatalogItemTraits from "../../../Traits/TraitsClasses/WebMapTileServiceCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import WebMapTileServiceCapabilities from "./WebMapTileServiceCapabilities";
export const SUPPORTED_CRS_3857 = [/EPSG.*3857/, /EPSG.*900913/];
export const SUPPORTED_CRS_4326 = [/EPSG.*4326/, /CRS.*84/, /EPSG.*4283/];
let GetCapabilitiesStratum = (_class = (_GetCapabilitiesStratum = class GetCapabilitiesStratum extends LoadableStratum(WebMapTileServiceCatalogItemTraits) {
  static async load(catalogItem, capabilities) {
    if (!isDefined(catalogItem.getCapabilitiesUrl)) {
      throw new TerriaError({
        title: i18next.t("models.webMapTileServiceCatalogItem.missingUrlTitle"),
        message: i18next.t("models.webMapTileServiceCatalogItem.missingUrlMessage")
      });
    }
    if (!isDefined(capabilities)) capabilities = await WebMapTileServiceCapabilities.fromUrl(proxyCatalogItemUrl(catalogItem, catalogItem.getCapabilitiesUrl, catalogItem.getCapabilitiesCacheDuration));
    return new GetCapabilitiesStratum(catalogItem, capabilities);
  }
  constructor(catalogItem, capabilities) {
    super();
    this.catalogItem = catalogItem;
    this.capabilities = capabilities;
    makeObservable(this);
  }
  duplicateLoadableStratum(model) {
    return new GetCapabilitiesStratum(model, this.capabilities);
  }
  get layer() {
    let layer;
    if (this.catalogItem.uri !== undefined) {
      const query = this.catalogItem.uri.query(true);
      layer = query.layer;
    }
    return layer;
  }
  get info() {
    const result = [createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.webMapTileServiceCatalogItem.getCapabilitiesUrl"),
      content: this.catalogItem.getCapabilitiesUrl
    })];
    let layerAbstract;
    const layer = this.capabilitiesLayer;
    if (layer && layer.Abstract && !containsAny(layer.Abstract, WebMapTileServiceCatalogItem.abstractsToIgnore)) {
      result.push(createStratumInstance(InfoSectionTraits, {
        name: i18next.t("models.webMapTileServiceCatalogItem.dataDescription"),
        content: layer.Abstract
      }));
      layerAbstract = layer.Abstract;
    }
    const serviceIdentification = this.capabilities && this.capabilities.ServiceIdentification;
    if (serviceIdentification) {
      if (serviceIdentification.Abstract && !containsAny(serviceIdentification.Abstract, WebMapTileServiceCatalogItem.abstractsToIgnore) && serviceIdentification.Abstract !== layerAbstract) {
        result.push(createStratumInstance(InfoSectionTraits, {
          name: i18next.t("models.webMapTileServiceCatalogItem.serviceDescription"),
          content: serviceIdentification.Abstract
        }));
      }

      // Show the Access Constraints if it isn't "none" (because that's the default, and usually a lie).
      if (serviceIdentification.AccessConstraints && !/^none$/i.test(serviceIdentification.AccessConstraints)) {
        result.push(createStratumInstance(InfoSectionTraits, {
          name: i18next.t("models.webMapTileServiceCatalogItem.accessConstraints"),
          content: serviceIdentification.AccessConstraints
        }));
      }

      // Show the Access Constraints if it isn't "none" (because that's the default, and usually a lie).
      if (serviceIdentification.Fees && !/^none$/i.test(serviceIdentification.Fees)) {
        result.push(createStratumInstance(InfoSectionTraits, {
          name: i18next.t("models.webMapTileServiceCatalogItem.fees"),
          content: serviceIdentification.Fees
        }));
      }
    }
    const serviceProvider = this.capabilities && this.capabilities.ServiceProvider;
    if (serviceProvider) {
      result.push(createStratumInstance(InfoSectionTraits, {
        name: i18next.t("models.webMapTileServiceCatalogItem.serviceContact"),
        content: getServiceContactInformation(serviceProvider) || ""
      }));
    }
    if (!isDefined(this.catalogItem.tileMatrixSet)) {
      result.push(createStratumInstance(InfoSectionTraits, {
        name: i18next.t("models.webMapTileServiceCatalogItem.noUsableTileMatrixTitle"),
        content: i18next.t("models.webMapTileServiceCatalogItem.noUsableTileMatrixMessage")
      }));
    }
    return result;
  }
  get infoSectionOrder() {
    return [i18next.t("preview.disclaimer"), i18next.t("models.webMapTileServiceCatalogItem.noUsableTileMatrixTitle"), i18next.t("description.name"), i18next.t("preview.datasetDescription"), i18next.t("models.webMapTileServiceCatalogItem.dataDescription"), i18next.t("preview.serviceDescription"), i18next.t("models.webMapTileServiceCatalogItem.serviceDescription"), i18next.t("preview.resourceDescription"), i18next.t("preview.licence"), i18next.t("preview.accessConstraints"), i18next.t("models.webMapTileServiceCatalogItem.accessConstraints"), i18next.t("models.webMapTileServiceCatalogItem.fees"), i18next.t("preview.author"), i18next.t("preview.contact"), i18next.t("models.webMapTileServiceCatalogItem.serviceContact"), i18next.t("preview.created"), i18next.t("preview.modified"), i18next.t("preview.updateFrequency"), i18next.t("models.webMapTileServiceCatalogItem.getCapabilitiesUrl")];
  }
  get shortReport() {
    return !isDefined(this.catalogItem.tileMatrixSet) ? "".concat(i18next.t("models.webMapTileServiceCatalogItem.noUsableTileMatrixTitle"), ": ").concat(i18next.t("models.webMapTileServiceCatalogItem.noUsableTileMatrixMessage")) : undefined;
  }
  get legends() {
    var _this$catalogItem$ava;
    const layerAvailableStyles = (_this$catalogItem$ava = this.catalogItem.availableStyles.find(candidate => {
      var _this$capabilitiesLay;
      return candidate.layerName === ((_this$capabilitiesLay = this.capabilitiesLayer) === null || _this$capabilitiesLay === void 0 ? void 0 : _this$capabilitiesLay.Identifier);
    })) === null || _this$catalogItem$ava === void 0 ? void 0 : _this$catalogItem$ava.styles;
    const layerStyle = layerAvailableStyles === null || layerAvailableStyles === void 0 ? void 0 : layerAvailableStyles.find(candidate => candidate.identifier === this.catalogItem.style);
    if (isDefined(layerStyle === null || layerStyle === void 0 ? void 0 : layerStyle.legend)) {
      return [createStratumInstance(LegendTraits, {
        url: layerStyle.legend.url,
        urlMimeType: layerStyle.legend.urlMimeType
      })];
    }
  }
  get capabilitiesLayer() {
    const result = this.catalogItem.layer ? this.capabilities.findLayer(this.catalogItem.layer) : undefined;
    return result;
  }
  get availableStyles() {
    const result = [];
    if (!this.capabilities) {
      return result;
    }
    const layer = this.capabilitiesLayer;
    if (!layer) {
      return result;
    }
    const styles = layer && layer.Style ? Array.isArray(layer.Style) ? layer.Style : [layer.Style] : [];
    result.push({
      layerName: layer === null || layer === void 0 ? void 0 : layer.Identifier,
      styles: styles.map(style => {
        const wmtsLegendUrl = isReadOnlyArray(style.LegendURL) ? style.LegendURL[0] : style.LegendURL;
        let legendUri, legendMimeType;
        if (wmtsLegendUrl && wmtsLegendUrl["xlink:href"]) {
          legendUri = new URI(decodeURIComponent(wmtsLegendUrl["xlink:href"]));
          legendMimeType = wmtsLegendUrl.Format;
        }
        const legend = !legendUri ? undefined : createStratumInstance(LegendTraits, {
          url: legendUri.toString(),
          urlMimeType: legendMimeType
        });
        return {
          identifier: style.Identifier,
          isDefault: style.isDefault,
          abstract: style.Abstract,
          legend: legend
        };
      })
    });
    return result;
  }
  get usableTileMatrixSets() {
    const usableTileMatrixSets = {};
    const matrixSets = this.capabilities.tileMatrixSets;
    if (matrixSets === undefined) {
      return;
    }
    for (let i = 0; i < matrixSets.length; i++) {
      const matrixSet = matrixSets[i];
      if (!matrixSet.SupportedCRS || ![...SUPPORTED_CRS_3857, ...SUPPORTED_CRS_4326].some(crs => crs.test(matrixSet.SupportedCRS))) {
        continue;
      }
      // Usable tile matrix sets must have a single 256x256 tile at the root.
      const matrices = matrixSet.TileMatrix;
      if (!isDefined(matrices) || matrices.length < 1) {
        continue;
      }
      const levelZeroMatrix = matrices[0];
      if (!isDefined(levelZeroMatrix.TopLeftCorner)) {
        continue;
      }
      const scheme = SUPPORTED_CRS_3857.some(crs => crs.test(matrixSet.SupportedCRS)) ? new WebMercatorTilingScheme() : new GeographicTilingScheme();
      if (scheme instanceof WebMercatorTilingScheme) {
        const standardTilingScheme = new WebMercatorTilingScheme();
        const levelZeroTopLeftCorner = levelZeroMatrix.TopLeftCorner.split(" ");
        const startX = parseFloat(levelZeroTopLeftCorner[0]);
        const startY = parseFloat(levelZeroTopLeftCorner[1]);
        const rectangleInMeters = standardTilingScheme.rectangleToNativeRectangle(standardTilingScheme.rectangle);
        if (Math.abs(startX - rectangleInMeters.west) > 1 || Math.abs(startY - rectangleInMeters.north) > 1) {
          continue;
        }
      }
      if (defined(matrixSet.TileMatrix) && matrixSet.TileMatrix.length > 0) {
        const ids = matrixSet.TileMatrix.map(function (item) {
          return item.Identifier;
        });
        const firstTile = matrixSet.TileMatrix[0];
        usableTileMatrixSets[matrixSet.Identifier] = {
          identifiers: ids,
          tileWidth: firstTile.TileWidth,
          tileHeight: firstTile.TileHeight,
          scheme: scheme
        };
      }
    }
    return usableTileMatrixSets;
  }
  get rectangle() {
    const layer = this.capabilitiesLayer;
    if (!layer) {
      return;
    }
    const bbox = layer.WGS84BoundingBox;
    if (bbox) {
      const lowerCorner = bbox.LowerCorner.split(" ");
      const upperCorner = bbox.UpperCorner.split(" ");
      return {
        west: parseFloat(lowerCorner[0]),
        south: parseFloat(lowerCorner[1]),
        east: parseFloat(upperCorner[0]),
        north: parseFloat(upperCorner[1])
      };
    }
  }
  get style() {
    var _this$availableStyles, _layerAvailableStyles, _layerAvailableStyles2, _layerAvailableStyles3;
    if (!isDefined(this.catalogItem.layer)) return;
    const layerAvailableStyles = (_this$availableStyles = this.availableStyles.find(candidate => {
      var _this$capabilitiesLay2;
      return candidate.layerName === ((_this$capabilitiesLay2 = this.capabilitiesLayer) === null || _this$capabilitiesLay2 === void 0 ? void 0 : _this$capabilitiesLay2.Identifier);
    })) === null || _this$availableStyles === void 0 ? void 0 : _this$availableStyles.styles;
    return (_layerAvailableStyles = layerAvailableStyles === null || layerAvailableStyles === void 0 || (_layerAvailableStyles2 = layerAvailableStyles.find(style => style.isDefault)) === null || _layerAvailableStyles2 === void 0 ? void 0 : _layerAvailableStyles2.identifier) !== null && _layerAvailableStyles !== void 0 ? _layerAvailableStyles : layerAvailableStyles === null || layerAvailableStyles === void 0 || (_layerAvailableStyles3 = layerAvailableStyles[0]) === null || _layerAvailableStyles3 === void 0 ? void 0 : _layerAvailableStyles3.identifier;
  }
}, _defineProperty(_GetCapabilitiesStratum, "stratumName", "wmtsServer"), _GetCapabilitiesStratum), _applyDecoratedDescriptor(_class.prototype, "layer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "layer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "info", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "info"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "infoSectionOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "infoSectionOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shortReport", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shortReport"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "legends", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "legends"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "capabilitiesLayer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "capabilitiesLayer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "availableStyles", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableStyles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "usableTileMatrixSets", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "usableTileMatrixSets"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rectangle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rectangle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "style", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "style"), _class.prototype), _class);
let WebMapTileServiceCatalogItem = (_class2 = (_WebMapTileServiceCatalogItem = class WebMapTileServiceCatalogItem extends MappableMixin(GetCapabilitiesMixin(UrlMixin(CatalogMemberMixin(CreateModel(WebMapTileServiceCatalogItemTraits))))) {
  constructor() {
    super(...arguments);
    // hide elements in the info section which might show information about the datasource
    _defineProperty(this, "_sourceInfoItemNames", [i18next.t("models.webMapTileServiceCatalogItem.getCapabilitiesUrl")]);
    makeObservable(this);
  }
  get type() {
    return WebMapTileServiceCatalogItem.type;
  }
  async createGetCapabilitiesStratumFromParent(capabilities) {
    const stratum = await GetCapabilitiesStratum.load(this, capabilities);
    runInAction(() => {
      this.strata.set(GetCapabilitiesMixin.getCapabilitiesStratumName, stratum);
    });
  }
  async forceLoadMetadata() {
    if (this.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName) !== undefined) return;
    const stratum = await GetCapabilitiesStratum.load(this);
    runInAction(() => {
      this.strata.set(GetCapabilitiesMixin.getCapabilitiesStratumName, stratum);
    });
  }
  get cacheDuration() {
    if (isDefined(super.cacheDuration)) {
      return super.cacheDuration;
    }
    return "1d";
  }
  get imageryProvider() {
    var _this$tileWidth, _ref, _this$tileHeight;
    const stratum = this.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName);
    if (!isDefined(this.layer) || !isDefined(this.url) || !isDefined(stratum) || !isDefined(this.style)) {
      return;
    }
    const layer = stratum.capabilitiesLayer;
    const layerIdentifier = layer === null || layer === void 0 ? void 0 : layer.Identifier;
    if (!isDefined(layer) || !isDefined(layerIdentifier)) {
      return;
    }
    let format = "image/png";
    const formats = layer.Format;
    if (formats && (formats === null || formats === void 0 ? void 0 : formats.indexOf("image/png")) === -1 && (formats === null || formats === void 0 ? void 0 : formats.indexOf("image/jpeg")) !== -1) {
      format = "image/jpeg";
    }
    const baseUrl = this.getTileUrl(layer, stratum.capabilities, format);
    const tileMatrixSet = this.tileMatrixSet;
    if (!isDefined(tileMatrixSet)) {
      return;
    }
    const imageryProvider = new WebMapTileServiceImageryProvider({
      url: proxyCatalogItemUrl(this, baseUrl),
      layer: layerIdentifier,
      style: this.style,
      tileMatrixSetID: tileMatrixSet.id,
      tileMatrixLabels: tileMatrixSet.labels,
      minimumLevel: tileMatrixSet.minLevel,
      maximumLevel: tileMatrixSet.maxLevel,
      tileWidth: (_this$tileWidth = this.tileWidth) !== null && _this$tileWidth !== void 0 ? _this$tileWidth : tileMatrixSet.tileWidth,
      tileHeight: (_ref = (_this$tileHeight = this.tileHeight) !== null && _this$tileHeight !== void 0 ? _this$tileHeight : this.minimumLevel) !== null && _ref !== void 0 ? _ref : tileMatrixSet.tileHeight,
      tilingScheme: tileMatrixSet.scheme,
      format,
      credit: this.attribution
      // TODO: implement picking for WebMapTileServiceImageryProvider
      //enablePickFeatures: this.allowFeaturePicking
    });
    return imageryProvider;
  }
  getTileUrl(layer, capabilities, format) {
    let url = undefined;
    if (capabilities.OperationsMetadata && "GetTile" in capabilities.OperationsMetadata) {
      const gets = capabilities.OperationsMetadata.GetTile["Get"];
      for (let i = 0; i < gets.length; i++) {
        let constraints = gets[i].Constraint;
        if (constraints) {
          var _getEncodingConstrain;
          constraints = Array.isArray(constraints) ? constraints : [constraints];
          const getEncodingConstraint = constraints.find(element => element.name === "GetEncoding");
          const encodings = getEncodingConstraint === null || getEncodingConstraint === void 0 || (_getEncodingConstrain = getEncodingConstraint.AllowedValues) === null || _getEncodingConstrain === void 0 ? void 0 : _getEncodingConstrain.Value;
          if (encodings !== null && encodings !== void 0 && encodings.includes("KVP")) {
            url = gets[i]["xlink:href"];
          }
        } else if (gets[i]["xlink:href"]) {
          url = gets[i]["xlink:href"];
        }
      }
    }
    const resourceUrls = !layer.ResourceURL || Array.isArray(layer.ResourceURL) ? layer.ResourceURL : [layer.ResourceURL];
    if (resourceUrls && (this.requestEncoding === "RESTful" || !url)) {
      for (let i = 0; i < resourceUrls.length; i++) {
        const resourceUrl = resourceUrls[i];
        if (resourceUrl.resourceType === "tile" && resourceUrl.format.indexOf(format) !== -1 || resourceUrl.format.indexOf("png") !== -1) {
          url = resourceUrl.template;
        }
      }
    }
    return url !== null && url !== void 0 ? url : new URI(this.url).search("").toString();
  }
  get tileMatrixSet() {
    const stratum = this.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName);
    if (!this.layer) {
      return;
    }
    const layer = stratum.capabilitiesLayer;
    if (!layer) {
      return;
    }
    const usableTileMatrixSets = stratum.usableTileMatrixSets;
    let tileMatrixSetLinks = [];
    if (layer !== null && layer !== void 0 && layer.TileMatrixSetLink) {
      if (Array.isArray(layer === null || layer === void 0 ? void 0 : layer.TileMatrixSetLink)) {
        // eslint-disable-next-line no-unsafe-optional-chaining
        tileMatrixSetLinks = [...(layer === null || layer === void 0 ? void 0 : layer.TileMatrixSetLink)];
      } else {
        tileMatrixSetLinks = [layer.TileMatrixSetLink];
      }
    }
    let tileMatrixSetId = undefined;
    let maxLevel = 0;
    let minLevel = 0;
    let tileWidth = 256;
    let tileHeight = 256;
    let tileMatrixSetLabels = [];
    let scheme;
    for (let i = 0; i < tileMatrixSetLinks.length; i++) {
      const tileMatrixSet = tileMatrixSetLinks[i].TileMatrixSet;
      if (usableTileMatrixSets && usableTileMatrixSets[tileMatrixSet]) {
        tileMatrixSetId = tileMatrixSet;
        tileMatrixSetLabels = usableTileMatrixSets[tileMatrixSet].identifiers;
        tileWidth = Number(usableTileMatrixSets[tileMatrixSet].tileWidth);
        tileHeight = Number(usableTileMatrixSets[tileMatrixSet].tileHeight);
        scheme = usableTileMatrixSets[tileMatrixSet].scheme;
        break;
      }
    }
    if (!tileMatrixSetId) return undefined;
    if (Array.isArray(tileMatrixSetLabels)) {
      const levels = tileMatrixSetLabels.map(label => {
        const lastIndex = label.lastIndexOf(":");
        return Math.abs(Number(label.substring(lastIndex + 1)));
      });
      maxLevel = levels.reduce((currentMaximum, level) => {
        return level > currentMaximum ? level : currentMaximum;
      }, 0);
      minLevel = levels.reduce((currentMaximum, level) => {
        return level < currentMaximum ? level : currentMaximum;
      }, Infinity);
    }
    if (minLevel > 0) {
      for (let i = 0; i < minLevel; i++) {
        tileMatrixSetLabels.unshift("");
      }
    }
    return {
      id: tileMatrixSetId,
      labels: tileMatrixSetLabels,
      maxLevel: maxLevel,
      minLevel: minLevel,
      tileWidth: tileWidth,
      tileHeight: tileHeight,
      scheme: scheme
    };
  }
  forceLoadMapItems() {
    return Promise.resolve();
  }
  get mapItems() {
    if (isDefined(this.imageryProvider)) {
      return [{
        alpha: this.opacity,
        show: this.show,
        imageryProvider: this.imageryProvider,
        clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
      }];
    }
    return [];
  }
  get defaultGetCapabilitiesUrl() {
    if (this.uri) {
      return this.uri.clone().setSearch({
        service: "WMTS",
        version: "1.0.0",
        request: "GetCapabilities"
      }).toString();
    } else {
      return undefined;
    }
  }
}, _defineProperty(_WebMapTileServiceCatalogItem, "abstractsToIgnore", ["A compliant implementation of WMTS service.", "This is the reference implementation of WMTS 1.0.0"]), _defineProperty(_WebMapTileServiceCatalogItem, "type", "wmts"), _WebMapTileServiceCatalogItem), _applyDecoratedDescriptor(_class2.prototype, "cacheDuration", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "cacheDuration"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "imageryProvider", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "imageryProvider"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "tileMatrixSet", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "tileMatrixSet"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mapItems"), _class2.prototype), _class2);
export function getServiceContactInformation(contactInfo) {
  let text = "";
  if (contactInfo.ProviderName && contactInfo.ProviderName.length > 0) {
    text += contactInfo.ProviderName + "<br/>";
  }
  if (contactInfo.ProviderSite && contactInfo.ProviderSite["xlink:href"]) {
    text += contactInfo.ProviderSite["xlink:href"] + "<br/>";
  }
  const serviceContact = contactInfo.ServiceContact;
  if (serviceContact) {
    var _serviceContact$Conta;
    const invidualName = serviceContact.InvidualName;
    if (invidualName && invidualName.length > 0) {
      text += invidualName + "<br/>";
    }
    const contactInfo = (_serviceContact$Conta = serviceContact.ContactInfo) === null || _serviceContact$Conta === void 0 ? void 0 : _serviceContact$Conta.Address;
    if (contactInfo && isDefined(contactInfo.ElectronicMailAddress) && contactInfo.ElectronicMailAddress.length > 0) {
      text += "[".concat(contactInfo.ElectronicMailAddress, "](mailto:").concat(contactInfo.ElectronicMailAddress, ")");
    }
  }
  return text;
}
export default WebMapTileServiceCatalogItem;